import clsx from 'clsx'

export interface MapMode {
  id: string
  num: string
  title: string
  sub: string
}

export interface MapModeSwitchProps {
  modes: MapMode[]
  active: string
  onPick: (id: string) => void
}

export function MapModeSwitch({ modes, active, onPick }: MapModeSwitchProps) {
  return (
    <div className="flex gap-1 rounded-[14px] border border-[rgba(15,23,42,0.07)] bg-white/85 p-1 shadow-[0_2px_8px_rgba(15,23,42,0.08)] backdrop-blur-sm">
      {modes.map((mode) => {
        const isActive = mode.id === active
        return (
          <button
            key={mode.id}
            type="button"
            aria-pressed={isActive}
            onClick={() => onPick(mode.id)}
            className={clsx(
              'flex min-w-[150px] items-center gap-2.5 rounded-[10px] px-3 py-2 text-left transition-colors',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2563EB]',
              isActive ? 'bg-[#0F172A]' : 'hover:bg-[rgba(15,23,42,0.05)]',
            )}
          >
            <span
              className={clsx(
                'flex h-5 w-5 shrink-0 items-center justify-center rounded-[6px] font-mono text-[10px] font-semibold',
                isActive ? 'bg-white/15 text-white' : 'bg-[#EEF2F7] text-[#64748B]',
              )}
            >
              {mode.num}
            </span>
            <span className="leading-tight">
              <span className={clsx('block text-[13px] font-bold', isActive ? 'text-white' : 'text-[#0F172A]')}>
                {mode.title}
              </span>
              <span className={clsx('block text-[11px]', isActive ? 'text-[#94A3B8]' : 'text-[#64748B]')}>
                {mode.sub}
              </span>
            </span>
          </button>
        )
      })}
    </div>
  )
}
